import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { HistoryService } from '@/services/history.service'

import { mapHistoryTasksToRows } from '../utils/history.mapper'

const getStatus = (error: unknown) =>
	error instanceof AxiosError ? error.response?.status : undefined

export const useHistory = () => {
	const {
		data: historyRows,
		isLoading: isHistoryLoading,
		isError,
		error,
		isFetching
	} = useQuery({
		queryKey: ['getHistoryTasks'],
		queryFn: () => HistoryService.getHistoryTasks(),
		select: response => mapHistoryTasksToRows(response.tasks),
		refetchInterval: (_data, query) => {
			const status = getStatus(query.state.error)

			return status === 403 ? false : 60000
		},
		retry: (failureCount, error) => {
			const status = getStatus(error)

			if (status === 403) return false

			return failureCount < 3
		}
	})

	const isEmpty = !historyRows?.length

	return {
		historyRows,
		isHistoryLoading,
		isError,
		error,
		isFetching,
		isEmpty
	}
}
